import React, { useState, useEffect } from "react";
import { NavLink, useRouteMatch, Link } from "react-router-dom";
import { withRouter } from "react-router";
import { logout } from "../../utils";
import Modal from "../Modal";
import Select from "react-select";
//import axios from "axios";

// img
import Hamburger from "../../Assets/hamburger.svg";
import logo from "../../Assets/Primis-Logo.svg";
import HomeIcon from "../../Assets/sidebar/home.svg";
import ProductIcon from "../../Assets/sidebar/Products.svg";
import ThemesIcon from "../../Assets/sidebar/themes.svg";
import UsersIcon from "../../Assets/sidebar/users.svg";
import ZipIcon from "../../Assets/sidebar/Zip.svg";
import VideoIcon from "../../Assets/sidebar/video.svg";
import ContactIcon from "../../Assets/sidebar/contact.svg";
import HelpIcon from "../../Assets/sidebar/help.svg";
import ServicesIcon from "../../Assets/sidebar/services.svg";
import QuestionsIcon from "../../Assets/sidebar/Questions.svg";
import ServiceRequestIcon from "../../Assets/sidebar/service-request.svg";
import SettingsIcon from "../../Assets/sidebar/settings.svg";
import RoleManagementIcon from "../../Assets/sidebar/role-management.svg";
import MobileConfiguration from "../../Assets/sidebar/mobile-configuration.svg";
import LogoutIcon from "../../Assets/sidebar/log-out.svg";
import ChangePasswordIcon from "../../Assets/sidebar/change-password.svg";
import UserIcon from "../../Assets/sidebar/user.svg";
import DownChevronIcon from "../../Assets/down-chevron.svg";
import SignupIcon from "../../Assets/sidebar/SignUp-URL.svg";
import HolidaysIcon from "../../Assets/sidebar/calendar.svg";
import AnnouncementIcon from "../../Assets/sidebar/announcments.svg";
import SafeIcon from "../../Assets/sidebar/safe-box-door-svgrepo-com.svg";

// style
import SidebarStyle from "./style";
import { Height } from "@mui/icons-material";
import { getFirstAvailablePath } from "../../utils/navigationPermissionsUtil";

function Sidebar(props) {
	const [OpenModal, setModal] = useState(false);
	const [bankList, setBankList] = useState([]);
	const [adminDropdownOpen, setAdminDropdownOpen] = useState(false);
	const [reconciliationDropdownOpen, setReconciliationDropdownOpen] =
		useState(false);
	const [contentDropdownOpen, setContentDropdownOpen] = useState(false);

	const toggleAdminDropdown = () => {
		setAdminDropdownOpen(!adminDropdownOpen);
	};

	const toggleReconciliationDropdown = () => {
		setReconciliationDropdownOpen(!reconciliationDropdownOpen);
	};
	const toggleContentDropdown = () => {
		setContentDropdownOpen(!contentDropdownOpen);
	};

	const findBank = (selected) => {
		for (let i = 0; i < bankList.length; i++) {
			if (bankList[i].value === selected) {
				return bankList[i];
			}
		}
	};

	const [selectedBankValue, setSelectedBankValue] = useState(
		findBank(parseInt(sessionStorage.getItem("selectedBank")))
	);
	const handleSelectBank = (e) => {
		sessionStorage.setItem("selectedBank", e.value);

		setSelectedBankValue(
			findBank(parseInt(sessionStorage.getItem("selectedBank")))
		);
		window.location.reload();
	};

	const handleModal = (e, type) => {
		e.preventDefault();
		setModal(type);
	};
	const CloseModal = (e, type) => {
		if (type === "logout_yes") {
			handleLogout();
		} else {
			setModal(!OpenModal);
		}
	};

	const match = useRouteMatch();
	function toArray(obj) {
		if (obj == null) {
			return [];
		} else if (Array.isArray(obj)) {
			return obj;
		} else {
			return [obj];
		}
	}

	function iif(condition, trueObj, falseObj) {
		return condition ? toArray(trueObj) : toArray(falseObj);
	}

	let sidebarList = [
		...iif(isModule(10), {
			icon: ServiceRequestIcon,
			name: "Service Requests",
			link: "service-request",
		}),
		...iif(isModule(4), {
			icon: UsersIcon,
			name: "Users",
			link: "users",
		}),
		{
			name: "Reconciliations",
			icon: SafeIcon,
			submenus: [
				...iif(isModule(20), {
					icon: SafeIcon,
					name: "Deposit Records",
					link: "reconciliations/safe-deposits",
				}),
				...iif(isModule(20), {
					icon: SafeIcon,
					name: "Smart Safe Records",
					link: "reconciliations/smart-safe",
				}),
			],
		},
		{
			name: "Content Management",
			icon: ThemesIcon,
			submenus: [
				...iif(isModule(1), {
					icon: HomeIcon,
					name: "Home",
					link: "home",
				}),
				...iif(isModule(2), {
					icon: ProductIcon,
					name: "Products",
					link: "product",
				}),
				...iif(isModule(8), {
					icon: ServicesIcon,
					name: "Services",
					link: "services",
				}),
				...iif(isModule(9), {
					icon: QuestionsIcon,
					name: "Questions",
					link: "questions",
				}),
				...iif(isModule(6), {
					icon: VideoIcon,
					name: "Social",
					link: "videos",
				}),
				...iif(isModule(12), {
					icon: HelpIcon,
					name: "Help",
					link: "help",
				}),
				...iif(isModule(7), {
					icon: ContactIcon,
					name: "Help - Contact Us",
					link: "contact-us",
				}),
				...iif(isModule(11), {
					icon: SettingsIcon,
					name: "Settings",
					link: "settings",
				}),
				...iif(isModule(3), {
					icon: ThemesIcon,
					name: "Themes",
					link: "themes",
				}),
			],
		},
		{
			name: "Administration",
			icon: RoleManagementIcon,
			submenus: [
				...iif(
					JSON.parse(sessionStorage.getItem("userDetails"))[0].user_roles[0]
						.role_id === 1 && sessionStorage.getItem("selectedBank") === "1",
					{
						icon: HomeIcon,
						name: "Banks",
						link: "banks",
					}
				),
				...iif(
					JSON.parse(sessionStorage.getItem("userDetails"))[0].user_roles[0]
						.role_id === 1,
					{
						icon: ContactIcon,
						name: "Administrators",
						link: "admin",
					}
				),
				...iif(isModule(16), {
					icon: HolidaysIcon,
					name: "Holidays",
					link: "holidays",
				}),
				...iif(isModule(15), {
					icon: AnnouncementIcon,
					name: "Announcements",
					link: "announcements",
				}),
				...iif(isModule(19), {
					icon: SafeIcon,
					name: "Safe Management",
					link: "safes",
				}),
				...iif(isModule(5), {
					icon: ZipIcon,
					name: "Zipcodes",
					link: "zipcodes",
				}),
			],
		},
	];

	const [UserOpen, setUserOpen] = useState(false);
	const [collapse, setCollapse] = useState(false);

	const handleLogout = () => {
		logout();
	};

	const handleUser = (e) => {
		e.preventDefault();
		setUserOpen(!UserOpen);
	};

	useEffect(() => {
		setBankList(props.bankListData);
	}, [props.bankListData]);

	useEffect(() => {
		setSelectedBankValue(
			findBank(parseInt(sessionStorage.getItem("selectedBank")))
		);
	});

	function isModule(id) {
		let retVal = true;
		let module = JSON.parse(
			sessionStorage.getItem("userDetails")
		)[0].user_permissions.find(
			(item) => item.module_id === id && item.status === 1
		);
		if (!module) retVal = false;
		return retVal;
	}

	return (
		<div
			className={
				!collapse
					? "dark-background sidebar sidebar-open"
					: "dark-background sidebar sidebar-close"
			}
		>
			<div
				className={
					!collapse
						? "d-flex pl-3 pt-3 pb-3"
						: "d-flex justify-content-center pt-3 pb-3"
				}
			>
				<img
					onClick={() => {
						props.collpase(!collapse);
						setCollapse(!collapse);
					}}
					src={Hamburger}
					className="hamburger cursor-pointer"
					alt="Hamburger"
				/>
				{!collapse && (
					<Link to={getFirstAvailablePath()}>
						<img
							src={logo}
							className="logo ml-4"
							alt="logo"
							width="150"
							height="90"
						/>
					</Link>
				)}
			</div>
			{(JSON.parse(sessionStorage.getItem("userDetails"))[0].bankid === 1 ||
				parseInt(sessionStorage.getItem("selectedBank")) === 1) && (
				<Select
					placeholder="Select Bank"
					isSearchable={false}
					onChange={(e) => handleSelectBank(e)}
					defaultValue={selectedBankValue}
					value={selectedBankValue}
					styles={{
						control: (baseStyles, state) => ({
							...baseStyles,
							borderColor: state.isFocused ? "#7a7a7a" : "#7a7a7a",
							marginLeft: "5px",
							marginRight: "5px",
							marginBottom: "5px",
							backgroundColor: "#575757",
							boxShadow: "none",
							"&:hover": {
								border: state.isFocused
									? "solid 1px #7a7a7a"
									: "solid 1px #7a7a7a",
							},
							"&:active": {
								border: state.isFocused
									? "solid 1px #7a7a7a"
									: "solid 1px #7a7a7a",
							},
						}),
						placeholder: (baseStyles, state) => ({
							...baseStyles,
							color: "#ffffff",
							borderColor: "#7a7a7a",
							backgroundColor: "#575757",
						}),
						indicatorSeparator: (baseStyles, state) => ({
							...baseStyles,
							color: state.isFocused ? "#ffffff" : "#ffffff",
						}),
						dropdownIndicator: (baseStyles, state) => ({
							...baseStyles,
							color: state.isFocused ? "#ffffff" : "#ffffff",
							"&:hover": {
								color: "#ffffff",
							},
						}),
						menuList: (baseStyles, state) => ({
							...baseStyles,
							color: state.isFocused ? "#ffffff" : "#ffffff",
							backgroundColor: "#575757",
						}),
						menu: (baseStyles, state) => ({
							...baseStyles,
							color: state.isFocused ? "#ffffff" : "#ffffff",
							backgroundColor: "#575757",
						}),
						singleValue: (baseStyles, state) => ({
							...baseStyles,
							color: state.isFocused ? "#ffffff" : "#ffffff",
							backgroundColor: "#575757",
						}),
						option: (baseStyles, state) => ({
							...baseStyles,
							color: state.isFocused ? "#ffffff" : "#ffffff",
							backgroundColor: "#575757",
							"&:hover": {
								backgroundColor: "#BDFF00",
								color: "black",
							},
						}),
					}}
					options={bankList}
				/>
			)}
			<div className="d-flex">
				{sessionStorage.getItem("userDetails") && (
					<ul className="pl-0 m-0 sidebar-list list-unstyled w-100">
						{sidebarList.map((item, index) => {
							if (item.name === "Reconciliations") {
								return (
									<div key={index}>
										<>
											<div
												onClick={toggleReconciliationDropdown}
												className={
													!collapse
														? "sidebar-list-item d-flex align-items-center cursor-pointer w-100 pl-3"
														: "sidebar-list-item d-flex align-items-center justify-content-center cursor-pointer w-100"
												}
											>
												<img src={item.icon} alt="SafeIcon" />
												{!collapse && (
													<span className="ml-3 f-14">{item.name}</span>
												)}
												<img
													src={DownChevronIcon}
													alt="DownChevronIcon"
													style={{
														marginLeft: !collapse ? "auto" : "1rem",
														marginRight: "8px", // Add padding to the right
														width: "auto",
														height: "auto",
														transition: "transform 0.3s",
														transform: reconciliationDropdownOpen
															? "rotate(180deg)"
															: "rotate(0deg)",
														transformOrigin: "center",
													}}
												/>
											</div>
											<div
												style={{
													marginLeft: "8px", // Add padding to the right
												}}
											>
												{reconciliationDropdownOpen && (
													<ul className="pl-0 m-0  list-unstyled w-100">
														{item.submenus.map((submenu, subIndex) => (
															<NavLink
																key={subIndex}
																activeClassName="sidebar-active"
																to={`${match.path}/${submenu.link}`}
																className={
																	!collapse
																		? "sidebar-list-item d-flex align-items-center cursor-pointer w-100 pl-3"
																		: "sidebar-list-item d-flex align-items-center justify-content-center cursor-pointer w-100"
																}
																style={{ height: "fit-content" }}
															>
																<img src={submenu.icon} alt="SubMenuIcon" />
																{!collapse && (
																	<span className="ml-3 f-14">
																		{submenu.name}
																	</span>
																)}
															</NavLink>
														))}
													</ul>
												)}
											</div>
										</>
									</div>
								);
							} else if (item.name === "Administration") {
								return (
									<div key={index}>
										<>
											<div
												onClick={toggleAdminDropdown}
												className={
													!collapse
														? "sidebar-list-item d-flex align-items-center cursor-pointer w-100 pl-3"
														: "sidebar-list-item d-flex align-items-center justify-content-center cursor-pointer w-100"
												}
											>
												<img src={item.icon} alt="AdminIcon" />
												{!collapse && (
													<span className="ml-3 f-14">{item.name}</span>
												)}
												<img
													src={DownChevronIcon}
													alt="DownChevronIcon"
													style={{
														marginLeft: !collapse ? "auto" : "1rem",
														marginRight: "8px", // Add padding to the right
														width: "auto",
														height: "auto",
														transition: "transform 0.3s",
														transform: adminDropdownOpen
															? "rotate(180deg)"
															: "rotate(0deg)",
														transformOrigin: "center",
													}}
												/>
											</div>
											<div
												style={{
													marginLeft: "8px", // Add padding to the right
												}}
											>
												{adminDropdownOpen && (
													<ul className="pl-0 m-0  list-unstyled w-100">
														{item.submenus.map((submenu, subIndex) => (
															<NavLink
																key={subIndex}
																activeClassName="sidebar-active"
																to={`${match.path}/${submenu.link}`}
																className={
																	!collapse
																		? "sidebar-list-item d-flex align-items-center cursor-pointer w-100 pl-3"
																		: "sidebar-list-item d-flex align-items-center justify-content-center cursor-pointer w-100"
																}
																style={{ height: "fit-content" }}
															>
																<img src={submenu.icon} alt="SubMenuIcon" />
																{!collapse && (
																	<span className="ml-3 f-14">
																		{submenu.name}
																	</span>
																)}
															</NavLink>
														))}
													</ul>
												)}
											</div>
										</>
									</div>
								);
							} else if (item.name === "Content Management") {
								return (
									<div key={index}>
										<>
											<div
												onClick={toggleContentDropdown}
												className={
													!collapse
														? "sidebar-list-item d-flex align-items-center cursor-pointer w-100 pl-3"
														: "sidebar-list-item d-flex align-items-center justify-content-center cursor-pointer w-100"
												}
											>
												<img src={item.icon} alt="ThemesIcon" />
												{!collapse && (
													<span className="ml-3 f-14">{item.name}</span>
												)}
												<img
													src={DownChevronIcon}
													alt="DownChevronIcon"
													style={{
														marginLeft: !collapse ? "auto" : "1rem",
														marginRight: "8px", // Add padding to the right
														width: "auto",
														height: "auto",
														transition: "transform 0.3s",
														transform: contentDropdownOpen
															? "rotate(180deg)"
															: "rotate(0deg)",
														transformOrigin: "center",
													}}
												/>
											</div>
											<div
												style={{
													marginLeft: "8px", // Add padding to the right
												}}
											>
												{contentDropdownOpen && (
													<ul className="pl-0 m-0  list-unstyled w-100">
														{item.submenus.map((submenu, subIndex) => (
															<NavLink
																key={subIndex}
																activeClassName="sidebar-active"
																to={`${match.path}/${submenu.link}`}
																className={
																	!collapse
																		? "sidebar-list-item d-flex align-items-center cursor-pointer w-100 pl-3"
																		: "sidebar-list-item d-flex align-items-center justify-content-center cursor-pointer w-100"
																}
																style={{ height: "fit-content" }}
															>
																<img src={submenu.icon} alt="SubMenuIcon" />
																{!collapse && (
																	<span className="ml-3 f-14">
																		{submenu.name}
																	</span>
																)}
															</NavLink>
														))}
													</ul>
												)}
											</div>
										</>
									</div>
								);
							} else {
								return (
									<>
										<div key={index}>
											<NavLink
												key={index}
												activeClassName="sidebar-active"
												to={`${match.path}/${item.link}`}
												className={
													!collapse
														? "sidebar-list-item d-flex align-items-center cursor-pointer w-100 pl-3"
														: "sidebar-list-item d-flex align-items-center justify-content-center cursor-pointer w-100"
												}
											>
												<img src={item.icon} alt="HomeIcon" />
												{!collapse && (
													<span className="ml-3 f-14">{item.name}</span>
												)}
											</NavLink>
										</div>
									</>
								);
							}
						})}
					</ul>
				)}
			</div>
			<div className="position-relative">
				{UserOpen && (
					<>
						<div
							style={
								props.location.pathname === "/dashboard/home" ||
								props.location.pathname === "/dashboard/product" ||
								props.location.pathname === "/dashboard/themes" ||
								props.location.pathname === "/dashboard/users" ||
								props.location.pathname === "/dashboard/zipcodes" ||
								props.location.pathname === "/dashboard/videos" ||
								props.location.pathname === "/dashboard/contact-us" ||
								props.location.pathname === "/dashboard/services" ||
								props.location.pathname === "/dashboard/questions" ||
								props.location.pathname === "/dashboard/service-request" ||
								props.location.pathname === "/dashboard/settings" ||
								props.location.pathname === "/dashboard/help" ||
								props.location.pathname === "/dashboard/mobile-configuration" ||
								props.location.pathname === "/dashboard/signup"
									? { zIndex: "9" }
									: {}
							}
							onClick={(e) => handleUser(e)}
							className="overlay"
						/>
						<div
							style={!collapse ? {} : { marginLeft: "-37px" }}
							className="bg-black user-popup position-absolute"
						>
							<div
								onClick={(e) => handleModal(e, "logout")}
								className="d-flex logout cursor-pointer"
							>
								<img src={LogoutIcon} alt="LogoutIcon" />
								<span className="m-0 text-white f-14 text-uppercase">
									Logout
								</span>
							</div>
							<NavLink
								to={`${match.path}/change-password`}
								onClick={() => setUserOpen(false)}
								className="d-flex logout cursor-pointer"
							>
								<img src={ChangePasswordIcon} alt="ChangePasswordIcon" />
								<span className="m-0 text-white f-14 text-uppercase">
									CHANGE PASSWORD
								</span>
							</NavLink>
						</div>
					</>
				)}
				<div
					onClick={(e) => handleUser(e)}
					className="d-flex logout cursor-pointer"
				>
					<img src={UserIcon} alt="UserIcon" />
					{!collapse && (
						<span className="m-0 text-white f-14">
							{JSON.parse(sessionStorage.getItem("userDetails"))[0].full_name}
						</span>
					)}
					<img
						src={DownChevronIcon}
						alt="DownChevronIcon"
						className={!collapse ? "ml-auto" : "ml-3"}
					/>
				</div>
			</div>
			<SidebarStyle />
			{OpenModal && (
				<Modal
					Name={""}
					Type={OpenModal}
					Close={(e, type) => CloseModal(e, type)}
				/>
			)}
		</div>
	);
}

export default withRouter(Sidebar);
